// Layouts
import RootLayout from "../layouts/Root/Root";
import LangLayout from "../layouts/Lang/Lang";
import HomeLayout from "../layouts/Home/Home";
// Pages
import ErrorPage from "../pages/Error/Error";
import HomePage from "../pages/Home/Home";
import GeneralTolerancePage from "../pages/Tolerance/General/General";

// Routes
import WidgetsRoute from "./Widgets";
import FanTolerancePage from "../pages/Tolerance/Fan/Fan";
import DriveshaftTolerancePage from "../pages/Tolerance/Driveshaft/Driveshaft";

/**
 * The root route tree for the main application.
 *
 * Structure:
 *   /                       → RootLayout (bare shell, just an Outlet)
 *     /:lang?               → LangLayout (reads lang segment, changes i18n language)
 *       (no path)           → HomeLayout (navigation bar + language switcher)
 *         index             → HomePage
 *         tolerance/        → tolerance calculators
 *           index           → GeneralTolerancePage
 *           general         → GeneralTolerancePage
 *           fan             → FanTolerancePage
 *           driveshaft      → DriveshaftTolerancePage
 *       widgets/...         → WidgetsRoute (bare widget pages, no nav shell)
 *
 * The Configurator page and its associated loaders were once intended to live
 * here (see the commented-out code below) but the feature was abandoned before
 * being wired into the router.
 */
const RootRoute = {
  path: "/",
  element: <RootLayout />,
  errorElement: <ErrorPage />,
  children: [
    {
      path: "/:lang?",
      element: <LangLayout />,
      children: [
        {
          element: <HomeLayout />,
          children: [
            {
              index: true,
              element: <HomePage />
            },
            {
              path: "tolerance",
              children: [
                {
                  index: true,
                  element: <GeneralTolerancePage />
                },
                {
                  path: "general",
                  element: <GeneralTolerancePage />
                },
                {
                  path: "fan",
                  element: <FanTolerancePage />
                },
                {
                  path: "driveshaft",
                  element: <DriveshaftTolerancePage />
                }
              ]
            }
          ]
        },
        WidgetsRoute
      ]
    },
  ],
};

//element: <SketchfabContextProvider><HomePage /></SketchfabContextProvider>,
//loader: SeriesLoader
//children: [
// {
//   path: ":id",
//   children: [
//     {
//       path: 'stands',
//       loader: getStands
//     },

//     {
//       path: 'filters',
//       loader: getFilters
//     },
//     {
//       path: 'auxiliaries',
//       loader: getAuxiliaries
//     },
//   ]
// },
// ]

export default RootRoute;
